import { getStore } from '../store/childStore';
import { mutatorAction } from 'satcheljs';
import { PopoutChildState } from '../store/schema/PopoutChildStore';
import { postMessage, PopoutMessageType } from '../utils/crossWindowMessenger';

export default mutatorAction('setPopoutChildState', (state: PopoutChildState) => {
    const store = getStore();
    store.state = state;

    if (state == PopoutChildState.Ready && store.isPopoutV2 && window.opener) {
        // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
        // -> Error TS2345 (14,69): Argument of type 'null' is not assignable to parameter of type 'Object | undefined'.
        // @ts-expect-error
        postMessage(window.opener, PopoutMessageType.DeeplinkReady, null);
    }
});
